import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_cycle_professional_subscription_report_line_RowClass} from '../../../dbschema';

export class ClaimCycleProfessionalSubscriptionReportLineContainerModel extends BaseContainerModel {
  bl_aat_claim_cycle_professional_subscription_report_line: bl_aat_claim_cycle_professional_subscription_report_line_RowClass = new bl_aat_claim_cycle_professional_subscription_report_line_RowClass();
}
